require('./ProgramQuotes.scss');

const b = require('app/www/libs/b')('program-quotes');
const sliceString = require('app/common/libs/sliceString');

const React = require('react');
const PropTypes = require('prop-types');

const {withI18n} = require('app/www/components/contexts/I18n');

const Global = require('app/www/components/blocks/Global/Global');
const Link = require('app/www/components/blocks/Link/Link');
const ProgramSubtitle = require('app/www/components/blocks/ProgramSubtitle/ProgramSubtitle');

const QUOTES_COUNT = 3;
const TEXT_LENGTH = 280;

class ProgramQuotes extends React.PureComponent {

    constructor(props) {
        super(props);

        const {quotes} = this.props;
        this._quotes = quotes.slice(0, QUOTES_COUNT);
    }

    render() {
        const {i18n, quotes, programCoId} = this.props;

        const programSubtitleProps = {
            text: i18n.get('program-quotes.title'),
            link: quotes.length > QUOTES_COUNT && {
                url: Global.kinopoiskQuotesUrl(programCoId),
            },
        };

        const linkProps = {
            attrs: {
                target: '_blank',
            },
        };

        return (
            <div className={b()}>
                <div className={b('title')}>
                    <ProgramSubtitle {...programSubtitleProps} />
                </div>
                {this._quotes.map(quote => (
                    <Link
                        key={quote.url}
                        className={b('link')}
                        url={quote.url}
                        {...linkProps}
                    >
                        <span className={b('source')} dangerouslySetInnerHTML={{__html: quote.source}} />
                        <span className={b('meta')}><i dangerouslySetInnerHTML={{__html: quote.author}} /> • {quote.date}</span>
                        <span className={b('text')} dangerouslySetInnerHTML={{__html: sliceString(quote.text, TEXT_LENGTH)}} />
                    </Link>
                ))}
            </div>
        );
    }
}

ProgramQuotes.propTypes = {
    quotes: PropTypes.arrayOf(PropTypes.object),
    programCoId: PropTypes.number,
};

module.exports = withI18n(ProgramQuotes);
